import { T } from "@/lib/i18n";
import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { MessageCircle } from "lucide-react";
import { chatApi } from "@/lib/api";
import { ChatThread } from "./ChatThread";
import { PushToggle } from "./PushToggle";

export const ClientChat = () => {
  const [messages, setMessages] = useState([]);
  const [typing, setTyping] = useState(false);
  const load = useCallback(() => chatApi.mine().then((d) => { setMessages(d.messages); setTyping(d.typing); }).catch(() => {}), []);
  useEffect(() => {
    if (window.location.hash === "#chat") setTimeout(() => document.getElementById("chat")?.scrollIntoView({ behavior: "smooth" }), 300);
  }, []);
  useEffect(() => {
    load();
    const t = setInterval(load, 2500);
    return () => clearInterval(t);
  }, [load]);
  const send = async (text) => {
    try { const m = await chatApi.send(text); setMessages((p) => [...p, m]); }
    catch (e) { toast.error(e?.response?.data?.detail || T("Messaggio non inviato")); throw e; }
  };
  return (
    <div id="chat" data-testid="client-chat" className="border border-[#e4e4e7] bg-white scroll-mt-24">
      <div className="p-5 border-b border-[#e4e4e7] flex flex-wrap items-center gap-2">
        <MessageCircle className="w-4 h-4 text-[#E0262C]" />
        <h2 className="font-display text-xl mr-auto">{T("Messaggi con il team Aurora-ADV")}</h2>
        <PushToggle />
      </div>
      <ChatThread messages={messages} me="client" onSend={send} placeholder={T("Scrivi un messaggio al team… (Invio per inviare)")} testid="client-chat"
        typing={typing} typingLabel="Il team Aurora-ADV" onTyping={() => chatApi.typing().catch(() => {})} />
    </div>
  );
};

export const useChatUnread = (enabled) => {
  const [unread, setUnread] = useState(0);
  useEffect(() => {
    if (!enabled) return;
    const load = () => chatApi.unread().then((d) => setUnread(d.unread)).catch(() => {});
    load();
    const t = setInterval(load, 20000);
    return () => clearInterval(t);
  }, [enabled]);
  return unread;
};
